import OrderConfirmation from './OrderConfirmation';

export default OrderConfirmation;
